import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const MarketplaceInternalNoteCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Marketplace internal note",
    cell: (row) => row.marketplaceInternalNote || "",
  };
